import React from 'react'
import Layout from '../components/layout'
// import LifeCoach from '../components/LifeCoach'
import Amplify, {API, graphqlOperation} from 'aws-amplify'
import graphql_endpoint from '../aws-appsync-url'
import LifeCoach from '../components/LifeCoachClient'
import {getMarketingPrograms} from "../queries";


class HomeIndex extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            programs: []
        }
    }
    componentDidMount() {
        Amplify.configure({
            API: {
                graphql_endpoint: graphql_endpoint.COACHING_MARKETING,
            },
        });
        API.graphql(graphqlOperation(getMarketingPrograms),{
            "x-api-key" : graphql_endpoint.API_KEY
        })
          .then(({ data }) => {
             this.setState({
                 programs: data?.getMarketingPrograms?.slice(0,6)
             })
          });
    }

    render() {
        return (
            <Layout
              show
              isLogoWhite
              increaseFooterMargin
              show120
            >
                <LifeCoach programs={this.state.programs} />
            </Layout>
        )
    }
}

export default HomeIndex
